<nb-card [accent]="status">
    <nb-card-header class="{{status}}">
        <nb-icon icon="{{setIcon(status)}}"></nb-icon>
        <h6>
            {{ header }}
        </h6>
    </nb-card-header>
    <nb-card-body [innerHtml]="body">
    </nb-card-body>
    <nb-card-footer>
        <button class="float-right" nbButton status="basic" (click)="dismiss()" ghost status="basic">Close</button>
    </nb-card-footer>
</nb-card>